/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Compliance_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Create a pattern rule with a keyword or regex and choose an action: audit, audit and block, or audit and require review. Every AI interaction is logged eithe..." |
*
* @param {Uno_Edu_Intro_Compliance_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_compliance_chip1_answer = /** @type {((inputs?: Uno_Edu_Intro_Compliance_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Compliance_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie eine Musterregel mit einem Schlüsselwort oder Regex und wählen Sie eine Aktion: protokollieren, protokollieren und blockieren oder protokollieren und Prüfung verlangen. Jede KI-Interaktion wird ohnehin protokolliert.")
	return /** @type {LocalizedString} */ ("Create a pattern rule with a keyword or regex and choose an action: audit, audit and block, or audit and require review. Every AI interaction is logged either way.")
});